import * as types from '@/store/mutation-types';

const getters = {
  searchResults: state => state.results,
};

const actions = {
  async searchSitesAndShafts({ commit }, payload) {
    try {
      let results = [];
      if (payload) {
        const sites = await this._vm.$directus.items('site').readByQuery({
          search: payload,
        });
        if (sites.data.length > 0) {
          sites.data.forEach(site => {
            results.push({ id: site.id, label: site.name, type: 'site' });
          });
        }
        const shafts = await this._vm.$directus.items('shafts').readByQuery({
          search: payload,
          fields: '*,site_id.*',
        });
        if (shafts.data.length > 0) {
          shafts.data.forEach(shaft => {
            var site = shaft.site_id ? ' (' + shaft.site_id.name + ')' : '';
            results.push({
              id: shaft.id,
              label: shaft.title + site,
              type: 'shaft',
            });
          });
        }
      }
      commit(types.SET_SEARCH_RESULTS, results);
    } catch (error) {
      //console.error(error);
      commit(types.SHOW_ERROR, error.message);
    }
  },
};

const mutations = {
  [types.SET_SEARCH_RESULTS](state, results) {
    state.results = results;
  },
};

const state = {
  results: [],
};

export default {
  state,
  getters,
  actions,
  mutations,
};
